<template>
  <img src="@/assets/img/community_banner.jpg" class="w-full max-h-[25rem] min-h-[11.25rem] object-cover"/>

  <main class="max-w-[1200px] mx-auto mb-20">
    <header class="header_w_search">
      <div></div>
      <h1 class="font-bold">커뮤니티</h1>
    </header>

    <div class="mb-12 px-6 pb-7 border-b flex justify-center gap-5 max-lg:grid max-lg:grid-cols-2 max-lg:gap-2">
      <router-link to="/community/1"  class="sec_btn w-full text-lg py-4 max-lg:text-base"
        active-class="!text-blue-800 !border-blue-800 !font-semibold">공지사항</router-link>
      <router-link to="/community/2"  class="sec_btn w-full text-lg py-4 max-lg:text-base"
        active-class="!text-blue-800 !border-blue-800 !font-semibold">자유게시판</router-link>
      <router-link to="/community/3"  class="sec_btn w-full text-lg py-4 max-lg:text-base"
        active-class="!text-blue-800 !border-blue-800 !font-semibold">Q&A</router-link>
      <router-link to="/community/4"  class="sec_btn w-full text-lg py-4 max-lg:text-base"
        active-class="!text-blue-800 !border-blue-800 !font-semibold">총회교육 웹진</router-link>
    </div>

    <!-- 검색 -->
    <div class="max-lg:px-5 mb-12">
      <div class="bg-neutral-100 border border-neutral-200 p-4 mt-2">  
        <div class="lg:flex mb-4">
          <span class="w-20">구분</span>
          <div class="flex flex-wrap items-center gap-2">
            <label class="check_btn gap-1">
              <input type="radio" name="board" v-model="selectedBoardId" value="" />
              전체
            </label>
            <label class="check_btn gap-1">
              <input type="radio" name="board" v-model="selectedBoardId" value="1" />
              공지사항
            </label>
            <label class="check_btn gap-1">
              <input type="radio" name="board" v-model="selectedBoardId" value="2" />
              자유게시판
            </label>
            <label class="check_btn gap-1">
              <input type="radio" name="board" v-model="selectedBoardId" value="3" />
              Q&A
            </label>
            <label class="check_btn gap-1">
              <input type="radio" name="board" v-model="selectedBoardId" value="4" />
              총회교육 웹진
            </label>
          </div>
        </div>
  
        <div class="lg:flex ">
          <span class="w-20">검색</span>
          <div class="flex max-lg:block gap-2 items-center">
            <select v-model="criteria" class="border p-1">
              <option value="all">제목+내용</option>
              <option value="title">제목</option>
              <option value="content">본문</option>
            </select>
            <input type="text" v-model="keyword" @keyup.enter="searchPostList" placeholder="검색어를 입력하세요" class="max-lg:w-[55vw] border p-1"/>
            <button type="button" @click="searchPostList" class="inline-block sec_btn px-5 py-1">검색</button>
          </div>
        </div>
      </div>
    </div>

    <div class="px-5">
      <div class="flex justify-between items-center">
        <h3 class="font-bold">{{ pageTitle }}</h3>
        <!-- 관리자만 작성 -->
        <div v-if="$route.path.endsWith('/1') || $route.path.endsWith('/4')">
          <router-link to="write" v-if="$store.state.level.id === 10" class="pri_btn px-3 py-2 text-lg">
            글 작성
          </router-link>
        </div>
        <router-link v-else to="write" class="pri_btn px-3 py-1 text-lg">
          글 작성
        </router-link>
      </div>

      <!-- 웹진 -->
      <div class="grid md:grid-cols-4 md:gap-12 grid-cols-2 gap-5 my-5" v-if="$route.path.endsWith('/4')">
        <div v-for="post in postList" :key="post.postId">
          <router-link :to="'/community/'+ post.boardId + '/' + post.postId">
            <img v-if="post.postThumbnail" :src="'http://118.67.134.110:18080' + post.postThumbnail" :alt="post.postTitle" class="w-full aspect-[7/10] object-cover"/>            
            <img v-else src="@/assets/img/null_img.jpg" class="w-full aspect-[7/10] object-cover border border-neutral-200"/>
            <div class="flex items-baseline gap-1 mt-4 ">
              <div class="w-fit mx-auto" v-if="post.seq === null">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M11.3349 2.40752L11.4054 2.46977L15.5304 6.59477C15.6568 6.72188 15.7336 6.89007 15.7467 7.06887C15.7598 7.24767 15.7084 7.42525 15.6018 7.56943C15.4953 7.71361 15.3406 7.81485 15.1658 7.85482C14.9911 7.89478 14.8078 7.87082 14.6492 7.78727L12.2702 10.1655L11.2022 13.0133C11.174 13.0884 11.134 13.1586 11.0837 13.221L11.0312 13.281L9.90616 14.406C9.77692 14.535 9.60504 14.6125 9.42278 14.6238C9.24051 14.6351 9.06037 14.5796 8.91616 14.4675L8.84491 14.4053L6.75016 12.3113L3.90541 15.1553C3.77044 15.2898 3.58933 15.3679 3.39887 15.3737C3.20841 15.3795 3.02287 15.3126 2.87995 15.1866C2.73702 15.0606 2.64743 14.8849 2.62936 14.6952C2.61129 14.5055 2.6661 14.316 2.78266 14.1653L2.84491 14.0948L5.68891 11.25L3.59491 9.15527C3.46578 9.02613 3.3882 8.8543 3.37674 8.67203C3.36528 8.48976 3.42072 8.30957 3.53266 8.16527L3.59491 8.09477L4.71991 6.96977C4.7765 6.91298 4.84183 6.86563 4.91341 6.82952L4.98691 6.79802L7.83391 5.72927L10.2122 3.35177C10.1311 3.20015 10.1045 3.02526 10.137 2.8564C10.1695 2.68754 10.259 2.53497 10.3905 2.42424C10.5221 2.31352 10.6877 2.25136 10.8596 2.24818C11.0316 2.24499 11.1993 2.30174 11.3349 2.40752Z" fill="#FF4A4A"/>
                </svg>
              </div>
              <p class="truncate2 max-md:text-sm">
                {{ post.postTitle }}
              </p>
            </div>

          </router-link>
        </div>
      </div>
      
      <div class="table_grid_container" v-else>
        <table class="table_grid_wrapper">
          <tr class="table_grid_header">
            <th>No.</th>
            <th>제목</th>
            <th class="max-md:hidden">작성자</th>
            <th class="max-md:hidden">작성일</th>
            <th class="max-lg:hidden">조회수</th>
          </tr>
          <tr class="table_grid_body" v-for="post in postList" :key="post.postId" v-if="postList.length > 0">
            <td class="text-center">
              <!-- 상단 고정 -->
              <div class="w-fit mx-auto" v-if="post.seq === null">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M11.3349 2.40752L11.4054 2.46977L15.5304 6.59477C15.6568 6.72188 15.7336 6.89007 15.7467 7.06887C15.7598 7.24767 15.7084 7.42525 15.6018 7.56943C15.4953 7.71361 15.3406 7.81485 15.1658 7.85482C14.9911 7.89478 14.8078 7.87082 14.6492 7.78727L12.2702 10.1655L11.2022 13.0133C11.174 13.0884 11.134 13.1586 11.0837 13.221L11.0312 13.281L9.90616 14.406C9.77692 14.535 9.60504 14.6125 9.42278 14.6238C9.24051 14.6351 9.06037 14.5796 8.91616 14.4675L8.84491 14.4053L6.75016 12.3113L3.90541 15.1553C3.77044 15.2898 3.58933 15.3679 3.39887 15.3737C3.20841 15.3795 3.02287 15.3126 2.87995 15.1866C2.73702 15.0606 2.64743 14.8849 2.62936 14.6952C2.61129 14.5055 2.6661 14.316 2.78266 14.1653L2.84491 14.0948L5.68891 11.25L3.59491 9.15527C3.46578 9.02613 3.3882 8.8543 3.37674 8.67203C3.36528 8.48976 3.42072 8.30957 3.53266 8.16527L3.59491 8.09477L4.71991 6.96977C4.7765 6.91298 4.84183 6.86563 4.91341 6.82952L4.98691 6.79802L7.83391 5.72927L10.2122 3.35177C10.1311 3.20015 10.1045 3.02526 10.137 2.8564C10.1695 2.68754 10.259 2.53497 10.3905 2.42424C10.5221 2.31352 10.6877 2.25136 10.8596 2.24818C11.0316 2.24499 11.1993 2.30174 11.3349 2.40752Z" fill="#FF4A4A"/>
                </svg>
              </div>
              <p v-else>{{post.seq}}</p>
            </td>
            <td class="lg:max-w-[43.75rem] md:max-w-[70vw] max-w-[88vw]">
              <router-link :to="'/community/'+ post.boardId + '/' + post.postId" class="flex items-center gap-2 text-left cursor-pointer">
                <!-- 비밀글 -->
                <div v-if="post.isSecret === true">
                  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none">
                    <path d="M8.99992 4.66671H8.41658V3.50004C8.41658 1.89004 7.10992 0.583374 5.49992 0.583374C3.88992 0.583374 2.58325 1.89004 2.58325 3.50004V4.66671H1.99992C1.35825 4.66671 0.833252 5.19171 0.833252 5.83337V11.6667C0.833252 12.3084 1.35825 12.8334 1.99992 12.8334H8.99992C9.64159 12.8334 10.1666 12.3084 10.1666 11.6667V5.83337C10.1666 5.19171 9.64159 4.66671 8.99992 4.66671ZM5.49992 9.91671C4.85825 9.91671 4.33325 9.39171 4.33325 8.75004C4.33325 8.10837 4.85825 7.58337 5.49992 7.58337C6.14159 7.58337 6.66658 8.10837 6.66658 8.75004C6.66658 9.39171 6.14159 9.91671 5.49992 9.91671ZM3.74992 4.66671V3.50004C3.74992 2.53171 4.53159 1.75004 5.49992 1.75004C6.46825 1.75004 7.24992 2.53171 7.24992 3.50004V4.66671H3.74992Z" fill="#B7BABD"/>
                  </svg>
                </div>

                <p class=" overflow-hidden truncate whitespace-nowrap max-w-[55vw]">
                  {{ post.postTitle }}
                </p>

                <!-- 댓글 수 -->
                <span class="inline-flex items-center text-sm" v-if="post.commentCount > 0">
                  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                    <path d="M5.93757 6C5.93757 6.14918 5.99683 6.29226 6.10232 6.39775C6.20781 6.50324 6.35088 6.5625 6.50007 6.5625C6.64925 6.5625 6.79232 6.50324 6.89781 6.39775C7.0033 6.29226 7.06257 6.14918 7.06257 6C7.06257 5.85082 7.0033 5.70774 6.89781 5.60225C6.79232 5.49676 6.64925 5.4375 6.50007 5.4375C6.35088 5.4375 6.20781 5.49676 6.10232 5.60225C5.99683 5.70774 5.93757 5.85082 5.93757 6ZM8.28132 6C8.28132 6.14918 8.34058 6.29226 8.44607 6.39775C8.55156 6.50324 8.69463 6.5625 8.84382 6.5625C8.993 6.5625 9.13607 6.50324 9.24156 6.39775C9.34705 6.29226 9.40632 6.14918 9.40632 6C9.40632 5.85082 9.34705 5.70774 9.24156 5.60225C9.13607 5.49676 8.993 5.4375 8.84382 5.4375C8.69463 5.4375 8.55156 5.49676 8.44607 5.60225C8.34058 5.70774 8.28132 5.85082 8.28132 6ZM3.59382 6C3.59382 6.14918 3.65308 6.29226 3.75857 6.39775C3.86406 6.50324 4.00713 6.5625 4.15632 6.5625C4.3055 6.5625 4.44858 6.50324 4.55406 6.39775C4.65955 6.29226 4.71882 6.14918 4.71882 6C4.71882 5.85082 4.65955 5.70774 4.55406 5.60225C4.44858 5.49676 4.3055 5.4375 4.15632 5.4375C4.00713 5.4375 3.86406 5.49676 3.75857 5.60225C3.65308 5.70774 3.59382 5.85082 3.59382 6ZM11.3423 3.96562C11.0774 3.33633 10.6977 2.77148 10.2137 2.28633C9.73314 1.80398 9.16261 1.42057 8.53444 1.15781C7.88991 0.887109 7.20554 0.75 6.50007 0.75H6.47663C5.76647 0.753516 5.07858 0.894141 4.43171 1.1707C3.80892 1.43616 3.24373 1.82025 2.76764 2.30156C2.28835 2.78555 1.91218 3.34805 1.65202 3.975C1.38249 4.62422 1.24655 5.31445 1.25007 6.02461C1.25404 6.83844 1.44658 7.64028 1.81257 8.36719V10.1484C1.81257 10.2914 1.86936 10.4285 1.97045 10.5296C2.07155 10.6307 2.20866 10.6875 2.35163 10.6875H4.13405C4.86096 11.0535 5.6628 11.246 6.47663 11.25H6.50124C7.20319 11.25 7.88405 11.1141 8.52507 10.848C9.15006 10.5884 9.71846 10.2095 10.1985 9.73242C10.6825 9.25313 11.0633 8.69297 11.3294 8.06836C11.6059 7.42148 11.7466 6.73359 11.7501 6.02344C11.7536 5.30977 11.6153 4.61719 11.3423 3.96562ZM9.57155 9.09844C8.75007 9.91172 7.66022 10.3594 6.50007 10.3594H6.48014C5.7735 10.3559 5.07155 10.1801 4.45163 9.84961L4.35319 9.79688H2.70319V8.14688L2.65046 8.04844C2.31999 7.42852 2.14421 6.72656 2.14069 6.01992C2.136 4.85156 2.58249 3.75469 3.40163 2.92852C4.2196 2.10234 5.31296 1.64531 6.48132 1.64062H6.50124C7.08718 1.64062 7.65554 1.7543 8.19108 1.9793C8.71374 2.19844 9.18249 2.51367 9.58561 2.9168C9.98757 3.31875 10.304 3.78867 10.5231 4.31133C10.7505 4.85273 10.8641 5.42695 10.8618 6.01992C10.8548 7.18711 10.3966 8.28047 9.57155 9.09844Z" fill="#898C92"/>
                  </svg>
                  <span class="text-neutral-400">{{post.commentCount}}</span>
                </span>

                <!-- 신규 글 -->
                <span
                  v-if="isNew(post.createdDateTime)"
                  class="inline-block rounded-full bg-amber-400 text-white text-xs px-2 leading-normal">
                  N
                </span>
              </router-link>
            </td>
            <td class="max-md:hidden">{{ post.postAuthor }}</td>
            <td class="max-md:hidden">{{ formDate(post.createdDateTime) }}</td>
            <td class="max-lg:hidden">{{ post.postHit }}</td>
          </tr>
          <tr v-else>
            <td colspan="5">목록이 없습니다.</td>
          </tr>
        </table>
      </div>

      <pagination v-if="pageInfo.page"
        :pageInfo="pageInfo"
        :page="page"
        :size="size"
        @updatePage="updatePage"
      />

    </div>
  </main>
</template>

<script setup>
  import { ref, computed, onMounted, watchEffect } from 'vue';
  import axios from 'axios';
  import Pagination from '@/components/Pagination.vue';
  import { formDate } from '@/assets/js/util.js';
  import { useRoute, useRouter } from 'vue-router';
  const route = useRoute();
  const router = useRouter();

  const pageInfo = ref({});
  const postList = ref({});

  const titles = ref({
    '/community/1': '공지사항',
    '/community/2': '자유게시판',
    '/community/3': 'Q&A',
    '/community/4': '총회교육 웹진',
  });

  const pageTitle = computed(() => {
    if (searching.value) {
    return "검색 결과";
    } else {
      const currentPath = route.path;
      return titles.value[currentPath];
    }
  });

  const page = ref(1);
  const size = ref(12);

  const criteria = ref("all");
  const keyword = ref("");
  const selectedBoardId = ref('');

  const searching = ref(false); // 검색함 플래그

  // 게시글 목록 조회
  const getPostList = async () => {
    const boardIdValue = route.params.boardId || 1;
    searching.value = false;

    try {
      const res = await axios.get(
        `/new_api/post/list?page=${page.value}&size=${size.value}&boardId=${boardIdValue}`
      );
      pageInfo.value = res.data.data.pageInfo;
      postList.value = res.data.data.postList;
    } catch (err) {
      console.error(err);
    }
  };

  const searchPostList = async () => {
    const boardIdValue = selectedBoardId.value;
    searching.value = true;

    try {
      const res = await axios.get(
        `/new_api/post/list?page=1&size=${size.value}&boardId=${boardIdValue}&criteria=${criteria.value}&keyword=${keyword.value}`
      );

      pageInfo.value = res.data.data.pageInfo;
      postList.value = res.data.data.postList;

    } catch (err) {
      console.error(err);
    }
  };

  const updatePage = (num) => {
    page.value = num;
    getPostList();
  };

  onMounted(async () => {
    await getPostList();
  });

  watchEffect(() => {
    getPostList();
  });

  const isNew = (date) => {
    const today = new Date();
    today.setHours(today.getHours() - 24);
    return new Date(date) > today;
  };

</script>